import React from "react";

const DocumentGuideOverlay = ({
  width = "85%",
  height = "60%",
  instructionText = "Align document within the frame",
}) => {
  return (
    <div
      className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ pointerEvents: "none" }}
    >
      <div
        className="position-relative br_7"
        style={{
          width: width,
          height: height,
          border: "3px dashed rgba(255, 255, 255, 0.8)",
          boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.5)",
        }}
      >
        {/* Corner Indicators */}
        <div
          className="w_30x h_30x position-absolute"
          style={{
            top: "-2px",
            left: "-2px",
            borderTop: "4px solid var(--mastercolor2)",
            borderLeft: "4px solid var(--mastercolor2)",
            borderRadius: "8px 0 0 0",
          }}
        ></div>
        <div
          className="w_30x h_30x position-absolute"
          style={{
            top: "-2px",
            right: "-2px",
            borderTop: "4px solid var(--mastercolor2)",
            borderRight: "4px solid var(--mastercolor2)",
            borderRadius: "0 8px 0 0",
          }}
        ></div>
        <div
          className="w_30x h_30x position-absolute"
          style={{
            bottom: "-2px",
            left: "-2px",
            borderBottom: "4px solid var(--mastercolor2)",
            borderLeft: "4px solid var(--mastercolor2)",
            borderRadius: "0 0 0 8px",
          }}
        ></div>
        <div
          className="w_30x h_30x position-absolute"
          style={{
            bottom: "-2px",
            right: "-2px",
            borderBottom: "4px solid var(--mastercolor2)",
            borderRight: "4px solid var(--mastercolor2)",
            borderRadius: "0 0 8px 0",
          }}
        ></div>

        {/* Instruction Text */}
        {instructionText && (
          <div
            className="font_14 font_500  position-absolute text-center text-white"
            style={{
              bottom: "-40px",
              left: "50%",
              transform: "translateX(-50%)",
              whiteSpace: "nowrap",
              textShadow: "0 2px 4px rgba(0,0,0,0.8)",
            }}
          >
            {instructionText}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentGuideOverlay;
